import { useQuery } from '@tanstack/react-query';

import { api } from 'utils/axios';

const GET_DASHBOARD_QUERY = 'get-leads';

const getDashboardQuery = async () => {
    try {
        const response = await api.get(`/auth/dashboard`);
        return response.data;
    } catch (e) {
        console.error(e, 'Error fetching leads');
    }

};

const useDahboardQuery = () => {
    return useQuery({
        queryKey: [GET_DASHBOARD_QUERY],
        queryFn: () => getDashboardQuery(),
    });
};

export { useDahboardQuery, GET_DASHBOARD_QUERY };
